/*
 * @Author: 赵健
 * @Date: 2021-03-09 10:30:57
 * @LastEditTime: 2021-03-09 10:30:58
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \Develop1.0.1\src\router\modules\user.js
 */
import Layout from '@/layout'
const userRouter = {
  path: '/profile',
  component: Layout,
  hidden: true,
  meta: { title: '用户中心' },
  children: [
    {
      path: '/profile/updatePassword',
      component: () => import('@/views/profile/updatePassword'),
      name: 'profileUpdatePassword',
      // hidden: true,
      meta: { title: '修改密码', noCache: true, icon: 'menu_pwd' }
    }

  ]
}
export default userRouter
